'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getInterest = function getInterest(interest, defaultValue) {
  if (interest !== undefined) {
    return interest;
  }

  return defaultValue;
};

var getValue = function getValue() {
  var jobInterest = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var userInterest = arguments[1];
  var constants = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var userValue = getInterest(userInterest, constants.DEFAULT);
  if (jobInterest.critical) {
    if (userValue < constants.CRITICAL_CUTOFF) {
      console.log('do the penalty');
      return constants.CRITICAL_PENALTY;
    }

    return constants.CRITICAL_BOOST;
  }

  var jobValue = getInterest(jobInterest.value, constants.DEFAULT);
  if (Math.abs(userValue - jobValue) > 0) {
    if (Math.abs(userValue - jobValue) < 3) {
      return Math.abs(userValue - jobValue) - 1;
    } else {
      return Math.abs(userValue - jobValue) * (Math.abs(userValue - jobValue) / 4);
    }
  }
  return Math.abs(userValue - jobValue);
};

exports.default = getValue;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/utils/match/interest/getValue.js
// module id = 1315
// module chunks = 0